import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HealthCierge from "@/pages/HealthCierge";
import PublicReceipt from "@/pages/PublicReceipt";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Toaster
                    position="bottom-right"
                    toastOptions={{
                        style: {
                            borderRadius: 0,
                            border: "1px solid #DCD8D3",
                            background: "#FFFFFF",
                            color: "#0A0A0A",
                            fontFamily: "IBM Plex Sans, sans-serif",
                            fontSize: 13,
                        },
                    }}
                />
                <Routes>
                    <Route path="/" element={<HealthCierge />} />
                    <Route path="/r/:hash" element={<PublicReceipt />} />
                    <Route path="/receipt/:hash" element={<PublicReceipt />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
